export default __webpack_public_path__ + "static/media/1.581ca7ea.png";